import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue')
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('@/views/News.vue')
  },
  {
    path: '/news/detail/:id',
    name: 'NewsDetail',
    component: () => import('@/views/NewsDetail.vue')
  },
  {
    path: '/services',
    name: 'Services',
    component: () => import('@/views/Services.vue')
  },
  {
    path: '/cases',
    name: 'Cases',
    component: () => import('@/views/Cases.vue')
  },
  {
    path: '/cases/detail/:id',
    name: 'CasesDetail',
    component: () => import('@/views/CasesDetail.vue')
  },
  {
    path: '/responsibility',
    name: 'Responsibility',
    component: () => import('@/views/Responsibility.vue')
  },
  {
    path: '/party-building',
    name: 'PartyBuilding',
    component: () => import('@/views/PartyBuilding.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/views/Contact.vue')
  },
  {
    path: '/recruit/detail/:id',
    name: 'RecruitDetail',
    component: () => import('@/views/RecruitDetail.vue')
  },
  {
    path: '*',
    redirect: '/'
  }
]

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // 支持 hash 锚点跳转（如 /about#overview）
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const element = document.querySelector(to.hash)
          if (element) {
            const top = element.offsetTop - 80 // 减去导航栏高度
            window.scrollTo({ top, behavior: 'smooth' })
            resolve()
          } else {
            resolve({ x: 0, y: 0 })
          }
        }, 300)
      })
    }
    return { x: 0, y: 0 }
  }
})
